import { warnIfOfflineNoCache } from '@school-manage/utils/offline';
import { createFileRoute } from '@tanstack/react-router';

import { NewsError } from './-components/error/NewsError';
import { News } from './-components/News';
import { useNews } from './-logic/useNews';
import { NewsContext } from './-logic/useNewsContext';

export const Route = createFileRoute('/_authed/news/')({
  beforeLoad: ({ context: { queryClient }, location }) => {
    warnIfOfflineNoCache(location, [queryClient.getQueryData(['news'])]);
  },
  component: NewsPage,
  errorComponent: NewsError,
});

function NewsPage() {
  return (
    <NewsContext.Provider value={useNews()}>
      <News />
    </NewsContext.Provider>
  );
}
